import Axios from '../helpers/api_client';
import {baseUserDetails, baseProfile, userAccess} from '../api_urls';
export function fetchUserDetails() {
  const query = baseUserDetails;
  return Axios.get(process.env.REACT_APP_API_GATEWAY_URL + query).then(
    (res) => {
      if (res.status != 200) {
        throw res?.data?.message;
      }
      return res.data;
    },
  );
}

export function fetchEmployeeDetails() {
  const query = 'employee/detail/';
  return Axios.get(process.env.REACT_APP_API_HRMS_BASE_URL + query).then(
    (res) => {
      if (res.status != 200) {
        throw res?.data?.message;
      }
      return res.data;
    },
  );
}

export function fetchVersionDetails() {
  const query = 'versionDetails/getCurrentVersion/';
  return Axios.get(process.env.REACT_APP_API_GATEWAY_URL + query).then(
    (res) => {
      if (res.status != 200) {
        throw res?.data?.message;
      }
      return res.data;
    },
  );
}

export function fetchProfileInfo(userId) {
  return Axios.get(
    `${process.env.REACT_APP_API_GATEWAY_URL}${baseProfile}?userId=${userId}`,
  ).then((res) => {
    if (res.status != 200) {
      throw res.data.message;
    }
    return res.data;
  });
}
export function fetchUserAccessPermissions() {
  return Axios.get(
    `${process.env.REACT_APP_API_GATEWAY_IAM_URL}${process.env.REACT_APP_API_WFM_USER_ACCESS_URL}`,
  ).then((res) => {
    if (res.status != 200) {
      throw res.data.message;
    }
    return res.data;
  });
}
